import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'className'
})
export class ClassPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return value.toLowerCase().replace(/ /g,'-');
  }

}
